import { createStore } from '@store/createStore';

const useGroupFacilitySwitcherStore = createStore(
  (set) => ({
    groupFacilitySwitcherValue: 'byFacility',

    actions: {
      setGroupFacilitySwitcher: (groupFacilitySwitcherValue) => set({ groupFacilitySwitcherValue }),
    },
  }),
  'GroupFacilitySwitcherStore',
);

export const useGroupFacilitySwitcherActions = () => useGroupFacilitySwitcherStore((state) => state.actions);

export const selectGroupFacilitySwitcher = () =>
  useGroupFacilitySwitcherStore((state) => state.groupFacilitySwitcherValue);
